<template>
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="emits('cancel')" @confirm="onConfirm">
    <el-form ref="formRef" @submit.native.prevent :model="projectForm" :rules="rules">
      <el-form-item prop="delivery_setting.budget_mode">
        <el-radio-group style="margin-left: 10px" class="radio-group" v-model="projectForm.delivery_setting.budget_mode">
          <div>
            <el-radio :label="BUDGET_MODE.INFINITE">不限</el-radio>
          </div>
          <div>
            <el-radio :label="BUDGET_MODE.DAY">
              <el-input
                v-model.trim="projectForm.delivery_setting.budget"
                @keyup.native.enter="onConfirm"
                placeholder="请输入预算"
              ></el-input>
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </Modal>
</template>

<script setup>
import { ref, toRefs } from 'vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import { BUDGET_MODE } from '@/views/create/bytedance/consts/index.js'
import { getProjectFormRules } from '@/views/create/bytedance/rules/index.js'
// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({
  currentRow: Object
})
const { currentRow } = toRefs(props)
const formRef = ref(null)
const rules = ref({})
const projectForm = ref({ delivery_setting: { budget: '' } })

function onModalOpen() {
  projectForm.value = currentRow.value.outer_plan_params
  rules.value = getProjectFormRules.call(projectForm.value)
}
function onConfirm() {
  formRef.value.validate((valid) => {
    if (valid) {
      emits('confirm', projectForm.value.delivery_setting)
    }
  })
}
</script>

<style lang="scss" scoped>
</style>
